(function($) {
    // Use the $ in peace...
  $(document).ready(function () {
    
    // Add click to call and Call to action
      $("a").click(function () {
          if (typeof gtag !== "undefined") {
              var href_value = $(this).attr("href");
              if (href_value != null && href_value !== '' && typeof(href_value) !== "undefined") {
                  var arr = href_value.split(":");
                  var current_url = $(location).attr('href');
                  if (arr[0] == 'tel') {
                      gtag('event', 'Click to Call', {
                          'event_category': 'Call to Action',
                          'event_label': current_url
                      });
//                        console.log(arr[0]);
                  }
                  else if (arr[0] == 'mailto') {
                      gtag('event', 'Click to Send Email', {
                          'event_category': 'Call to Action',
                          'event_label': current_url
                      });
//                        console.log(arr[0]);
                  }

              }
          }
          else if (typeof ga !== "undefined") {
              var href_value = $(this).attr("href");
              if (href_value != null && href_value !== '' && typeof(href_value) !== "undefined") {
                  var arr = href_value.split(":");
                  var current_url = $(location).attr('href');
                  if (arr[0] == 'tel') {
                      ga('send', 'event', 'Call to Action', 'Click to Call', current_url);
                   //   console.log(arr[0]);
                  }
                  else if (arr[0] == 'mailto') {
                      ga('send', 'event', 'Call to Action', 'Click to Send Email', current_url);
                   //   console.log(arr[0]);
                  }

              }
          }
      });

      $("button.btn--add-to-cart").click(function () {
          if (typeof gtag !== "undefined") {
              var current_url = $(location).attr('href');
                  
              gtag('event', 'Add to Cart', {
                  'event_category': 'Call to Action',
                  'event_label': current_url
              });
              console.log("Gtag add to cart");
          }
          else if (typeof ga !== "undefined") {
              var current_url = $(location).attr('href');
              ga('send', 'event', 'Call to Action', 'Add to Cart', current_url);
              console.log("Ga add to cart");
          }
      });
    
  })
  	
}(jQuery));